module.exports = __webpack_public_path__ + "static/img/fraud_1.96726925.png";